module.exports = __webpack_public_path__ + "img/aiva.4bbf7478.png";